export default __webpack_public_path__ + "static/PQ-icon-white-52e8b931b13d5f4e8aae1a4890262661.png";